import { DragBehaviorBase } from '../drag-behavior-base';
import { ObjectCheckerService } from '../../../../../services/object-checker.service';
import { CollisionService } from '../../../../../services/collision/collision.service';

declare let THREE: any;

export class WallObjectDrag extends DragBehaviorBase {
  protected dragPlane: any;
  protected clickPoint: any;
  protected objectsOffset: object = {};
  protected objectsViolation: object = {};

  constructor(
    handler,
    protected objectCheckerSrvc: ObjectCheckerService,
    protected collisionSrvc: CollisionService
  ) {
    super(handler);
    this.dragPlane = new THREE.Plane();
    this.clickPoint = new THREE.Vector3();
  }

  hold(e) {
    const { point, object } = e.intersection;
    const normal = new THREE.Vector3();
    object.getWorldDirection(normal);
    this.dragPlane.setFromNormalAndCoplanarPoint(normal, point);
    this.clickPoint.copy(point);
    super.hold(e);
  }

  move(e, transformation) {
    const { draggedObject, raycaster, draggedObjectWorldTransform } = e;
    const draggedObjectId = draggedObject.id;
    const objectsOffset = this.objectsOffset;

    raycaster.ray.intersectPlane(this.dragPlane, transformation.position);

    objectsOffset[draggedObjectId] =
      objectsOffset[draggedObjectId] ||
      this.clickPoint.clone().sub(draggedObjectWorldTransform.position);

    transformation.position.sub(objectsOffset[draggedObjectId]);

    super.move(e, transformation);

    const collided = this.collisionSrvc.isCollide(draggedObject, e.staticObjects, {
      newPosition: transformation.position
    });

    this.objectsViolation[draggedObjectId] = !!collided;

    const hasViolation = Object.values(this.objectsViolation).indexOf(true) !== -1;

    if (hasViolation) {
      transformation.position.copy(draggedObjectWorldTransform.position);
    }
  }

  release(e) {
    this.objectsOffset = {};
    this.objectsViolation = {};
    super.release(e);
  }

  getStaticObjectsFilter(objects) {
    const baseFilter = super.getStaticObjectsFilter(objects);
    return obj => baseFilter(obj) && !this.objectCheckerSrvc.isFloor(obj);
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Behavior/WallObject/wall-object-drag.ts